import React, { useState } from "react";
import Style from "./OrderListAll.module.scss";
import ProductInfoAll from "./ProductInfoAll/ProductInfoAll";
import Timer from "../../../Timer/Timer";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { Accordion, Modal } from "react-bootstrap";
import { randomNumberInRange } from "./../../../../Utils/RandomNumberInRange/RandomNumberInRange";
import { Alert } from "antd";

import TransactionList from "../../../List/TransactionList/TransactionList";
import { orderStatus } from "../../../../Utils/Helper/Helper";

const OrderListAll = ({ item, handleOk, Info }) => {
  const [modalShowState, setModalShowState] = useState(false);
  return (
    <div className={Style.supplier}>
      {item &&
        item.suppliers.map((val, index) => {
          return (
            <section key={index} className={Style.SupllierHolder}>
              <div className={Style.SupplierDiv}>
                <div className={Style.imageHolder}>
                  <img
                    src={`https://cdn.barest.ir/supplier/logo/${
                      val.logo
                    }.jpg?${randomNumberInRange(1, 1000000000000)}`}
                    alt=""
                  />
                </div>
                <div className={Style.supplierInfoHolder}>
                  <p>
                    نام:  <span style={{ color: "#ff0099" }}>{val.name}</span>
                  </p>
                  <p>
                    فروشنده:  
                    <span style={{ color: "#ff0099" }}>{val.seller}</span>
                  </p>
                  <p>کدپیک: {val.delivery_code}</p>
                  <p>
                    زمان تامین کننده :
                    <Timer Time={val.prepare_remaining_time} />
                  </p>
                  <p>
                    زمان پیک :<Timer Time={val.delivery_remaining_time} />
                  </p>
                  <a href={`tel:${val.phone}`}> تماس: {val.phone}</a>
                  {val.phone_2 ? (
                    <a href={`tel:${val.phone_2}`}> 2 تماس:{val.phone_2}</a>
                  ) : null}
                  {val.phone_3 ? (
                    <a href={`tel:${val.phone_3}`}> 3 تماس:{val.phone_3}</a>
                  ) : null}
                  <p>
                    مجموع خرید:{" "}
                    <span style={{ color: "green" }}>
                      {separate(val.total)} تومان
                    </span>
                  </p>
                  <p>
                    سود برست:{" "}
                    <span style={{ color: "red" }}>
                      {separate(val.feeTotal)} تومان
                    </span>
                  </p>
                </div>
                <p className={Style.AddressHolder}> آدرس: {val.address}</p>
                <Alert
                  style={{ width: "100%", direction: "rtl" }}
                  message={` وضعیت سفارش : ${orderStatus[val.status]}`}
                  type="info"
                  showIcon
                />
                <Accordion
                  style={{
                    width: "100%",
                    direction: "rtl",
                    marginTop: "0.75rem",
                  }}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header style={{ border: "1px solid #ff0099" }}>
                      لیست محصولات 
                    </Accordion.Header>
                    <Accordion.Body style={{ direction: "ltr" }}>
                      <ProductInfoAll
                        Price={Info.deliveryPrice}
                        data={val}
                        statusId={val.status}
                      />
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                {val.description&&<strong className={Style.OrderDescription}> توضیحات: {val.description}</strong>}
              </div>
            </section>
          );
        })}
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>وضعیت سفارش :</span>
        <span style={{ color: "black" }}>{orderStatus[item.orderStatus]}</span>
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>کد پیک :</span>
        {item.delivery_code}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>کرایه پرداختی مشتری :</span>
        {separate(item.deliver_price)}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>کرایه دریافتی پیک :</span>
        {separate(item.delivery_price)}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>مبلغ خرید :</span>
        {separate(item.total)}تومان{" "}
      </div>
      <div className={Style.totalPricePart}>
        <span style={{ color: "black" }}>مجموع پرداختی :</span>
        {separate(
          item.total +
            parseInt(item.deliver_price) -
            parseInt(item.discount_amount)
        )}
        تومان{" "}
      </div>
      <div className={Style.pFee}>
        <span style={{ color: "black" }}>مجموع کارمزد :</span>
        {item.orderStatus !== "3" ? ` تقریبا ` : null}
        {separate(
          parseInt(item.totalFee) +
            parseInt(item.deliver_price) -
            parseInt(item.delivery_price) -
            parseInt(item.referral)
        )}
        تومان{" "}
      </div>
      {item.discount_code ? (
        <div className={Style.orderDetail}>
          <span style={{ color: "black" }}> کد تخفیف استفاده شده :</span>
          {item.discount_codes}
        </div>
      ) : null}
      {item.discount_amount !== "0" ? (
        <div className={Style.orderDetail}>
          <span style={{ color: "black" }}> تخفیف اعمال شده:</span>
          {separate(item.discount_amount)}تومان{" "}
        </div>
      ) : null}

      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شخص تحویل گیرنده :</span>
        {item.person}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شماره سفارش دهنده :</span>
        { item.user_phone}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>شماره گیرنده سفارش :</span>
        {item.phone !== "" ? item.phone : item.user_phone}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>آدرس وارده نقشه :</span>
        {item.address}
      </div>
      <div className={Style.orderDetail}>
        <span style={{ color: "black" }}>آدرس نوشته شده مشتری :</span>
        <a href={`https://maps.apple.com/?q=${item.lon},${item.lat}`} target="_blank" rel="noreferrer">
        {`${item.city}، ${item.region}، ${item.street}، ${item.alley} ${
          item.apartment_name && "، " + item.apartment_name
        }${item.apartment_number !== "0" ? "، " + item.apartment_number : ""}`}
        </a>
      </div>

      <div className={Style.btnHolder}>
        <button onClick={handleOk} className={Style.ConfirmBtn}>
          تایید
        </button>
        <button
          onClick={() => setModalShowState(true)}
          className={Style.transactionBtn}
        >
          لیست تراکنشات
        </button>
      </div>
      <Modal
        size="xl"
        show={modalShowState}
        onHide={() => setModalShowState(false)}
        style={{ backdropFilter: "blur(2px)", direction: "rtl" }}
      >
        <Modal.Header>
          <Modal.Title>اطلاعات تراکنشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TransactionList data={item.transactions} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OrderListAll;
